import { createContext, useContext } from "solid-js";

/**
 * App layout context. The listto template exposed helpers here for
 * opening list/group dialogs; Apunte Digital (notes) does not need them, so
 * the context remains empty but is retained as an extension point.
 */
type AppLayoutContextValue = Record<string, never>;

export const AppLayoutContext = createContext<AppLayoutContextValue>();

export const useAppLayoutContext = () => {
  const context = useContext(AppLayoutContext);
  if (!context) {
    throw new Error("useAppLayoutContext must be used within an AppLayout");
  }
  return context;
};
